import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./CTA.css";

function CTA({
  title,
  subtitle,
  btnLabel,
  to = "/contact",
}) {
  const navigate = useNavigate();
  const { t } = useTranslation();
  
  return (
    <section className="cta">
      <h2 className="cta__title">{title || t("cta.title")}</h2>
      <p className="cta__sub">{subtitle || t("cta.subtitle")}</p>
      <button className="cta__btn" onClick={() => navigate(to)}>
        {btnLabel || t("cta.btnLabel")}
      </button>
    </section>
  );
}

export default CTA;
